import { Controller } from "../Controller";
import { NavigationItem } from "./NavigationItem";
import { ControllerRegistry } from "../../Registry/ControllerRegistry";
import { Navigation as NavigationTag } from "../../HTML/Navigation/Navigation";
import { Anchor } from "../../HTML/Anchor";
import type { Tag } from "../../HTML/Tag";
import { toMap, getService4App } from "../../../../HA";

export class Navigation extends Controller {
    /**
     *
     * @param data
     * @returns {any}
     */
    protected static createItemController(data: Map<any, any>) {
        const controllerName = data.get("controllerName");
        if (controllerName && ControllerRegistry.has(controllerName)) {
            return ControllerRegistry.create(controllerName, data);
        }

        return new NavigationItem(data);
    }

    /**
     * @param data
     */
    protected initialize(data: Map<any, any>) {
        super.initialize(data);
        this.addToData("tag", new NavigationTag(toMap(data)));
        this.initAnchors();
        if(this.has("skip")) {
            return;
        }
        this.initializeItems();
    }

    private initAnchors(tag?: Tag): void {
        tag = tag || this.getTag();
        const anchors = tag.fetchByTagName("a");
        anchors.forEach((anchor: Tag) => {
            if (anchor.getAttribute("i")) {
                return;
            }
            anchor.setAttribute("i", "1");
            const data = new Map();
            data.set("tag", anchor);
            data.set("services", getService4App());
            new Anchor(data);

        });
    }

    protected initializeItems() {
        this.addToData("itemControllers", new Map());
        const items = this.getItems();
        if (items) {
            items.forEach((item: any) => {
                this.addItem(toMap(item));
            });
        }
    }

    /**
     *
     * @param data
     */
    protected addItem(data: Map<any, any>) {
        const config = toMap(data);
        config.set("services", this.getItemService());
        config.set("pelement", this.getTag());
        this.getItemControllers().set(data.get("id"), Navigation.createItemController(config));
    }

    protected getItemService() {
        return this.get("services");
    }

    /**
     *
     * @returns {Map}
     */
    protected getItemControllers() {
        return this.get("itemControllers");
    }

    /**
     *
     * @returns {Map}
     */
    protected getItems() {
        return this.get("items");
    }
}

ControllerRegistry.register("Navigation", Navigation);
